import { ATTENDANCE_MODES } from '../constants/schedule.constants';

export function computeCheckInBreakdown(items, total) {
  if (!total || items.length !== total) return null;
  const virtual = items.filter(item => item.attendanceMode === ATTENDANCE_MODES.VIRTUAL).length;
  return { inPerson: total - virtual, virtual };
}
